import format from '@mobi/utils/formatters/number'
import { capitalizeAll } from 'utils/string'

const isHotDealPayment = (group) =>
  group.payment_options
    ?.filter((option) => option.is_hot_deal)
    .map((option) => PaymentOption(option))?.[0]

const handlePaymentValue = ({ group }) => {
  if (isHotDealPayment(group)) {
    return isHotDealPayment(group)
  } else {
    return PaymentOption(group.payment_options[0])
  }
}

export const DebtOrigin = ({
  origin = String(),
  value = String(),
  contract_number = String(),
  judiciary_processes = [''],
}) => ({
  name: capitalizeAll(origin),
  value: format({ value: value, style: 'currency' }),
  contractNumber: contract_number.replace(/\D/g, ''),
  judiciaryProcesses:
    judiciary_processes === null
      ? ''
      : judiciary_processes
          .filter((judiciaryProcess) => judiciaryProcess !== '')
          .map((judiciaryProcess) => judiciaryProcess.replace(/\D/g, '')),
})

export const PaymentOption = ({
  payment_option_id = String(),
  installment_number = Number(),
  installment_value = Number(),
  discount = Number(),
  discount_value = Number(),
  value = Number(),
  interest_rate = Number(),
  is_hot_deal = Boolean(),
}) => ({
  id: payment_option_id,
  installmentNumber: installment_number,
  installmentValue: format({ value: installment_value, style: 'currency' }),
  installmentValueRaw: installment_value,
  discount: `${parseInt(discount)}%`,
  discountRaw: discount,
  discountParsed: parseInt(discount),
  discountValue: format({ value: discount_value, style: 'currency' }),
  discountValueRaw: discount_value,
  value: format({ value, style: 'currency' }),
  valueRaw: value,
  interestRate: `${interest_rate}%`.replace('.', ','),
  isHotDeal: is_hot_deal,
})

const paymentDays = ({ date = String() }) => ({
  date: date,
})

const groupItem = ({
  debt_group_id = String(),
  group_name = String(),
  group_fund = String(),
  original_value = Number(),
  debt_origins = [DebtOrigin],
  payment_options = [PaymentOption],
  bar_code = String(),
}) => ({
  debt_group_id: debt_group_id,
  group_name: group_name,
  group_fund: group_fund,
  original_value: original_value,
  debt_origins: debt_origins,
  payment_options: payment_options,
  bar_code: bar_code,
})

const DebtGroup = ({
  group = [groupItem],
  payment_days = [paymentDays],
} = {}) => ({
  id: group.debt_group_id,
  name: group.group_name,
  fund:
    group.group_fund === 'IResolve Companhia Securitizadora'
      ? 'IResolve'
      : group.group_fund,
  fundTooltipText: group.group_fund?.includes('NPL')
    ? 'Fundo de Investimento em Direitos Creditórios não Padronizados NPL II que, por meio de uma cessão de crédito, adquiriu o direito de cobrança e recebimento de operação (ões) financeiras e que hoje estão sob gestão da Recovery, empresa especializada em cobrança.'
    : 'Iresolve Companhia Securitizadora de Créditos Financeiros S.A., que, por meio de uma cessão de crédito, adquiriu o direito de cobrança e recebimento de operação (ões) financeiras e que hoje estão sob gestão da Recovery, empresa especializada em cobrança.',
  originalValue: format({ value: group.original_value, style: 'currency' }),
  originalValueRaw: group.original_value,
  debtOrigins: group.debt_origins?.map(DebtOrigin),
  paymentOptions: group.payment_options?.map(PaymentOption),
  inCash: PaymentOption(group.payment_options[0]),
  barCode: group.bar_code,
  dueDateSelected: {
    date: payment_days?.length ? payment_days[0] : '',
    payment: handlePaymentValue({
      group,
    }),
  },
  walletId: group.wallet_id,
})

export default DebtGroup
